// Pure helpers for the Submit specimen (DESIGN_SPEC §12.15).
//   colsForWidth(fieldW)          240 columns while a glyph stays ≥ 2.6px (plate field ≥ 375px), else 120
//   portraitArt(portrait)         the portrait padded with blank rows to the moth's height (82 rows at 240 columns, 41 at 120),
//                                 centred; padTop = blank rows above (the gutter labels add it to their row)
//   portraitCaption(name, size, portrait, isPe)   the museum label: bytes per glyph, window, levels (min/median/max when not a PE)
//   pad4(n)                       "0015"
import { bytes, count } from "@/lib/format";
import { PORTRAIT_MAX, type Portrait } from "./entropy";

type PortraitArt = { cols: number; rows: number; lines: string[]; accent: never[] };

export const colsForWidth = (fieldW: number) => (fieldW >= 375 ? 240 : 120);

export const pad4 = (n: number) => String(n).padStart(4, "0");

export function portraitArt(p: Pick<Portrait, "grid" | "lines">): { art: PortraitArt; padTop: number } {
  const minRows = p.grid.cols === 240 ? 82 : 41;
  const total = Math.max(minRows, p.lines.length);
  const padTop = Math.floor((total - p.lines.length) / 2);
  const lines = [...Array<string>(padTop).fill(""), ...p.lines, ...Array<string>(total - padTop - p.lines.length).fill("")];
  return { art: { cols: p.grid.cols, rows: total, lines, accent: [] }, padTop };
}

const f2 = (n: number) => n.toFixed(2);

export function portraitCaption(name: string, size: number, p: Pick<Portrait, "grid" | "lo" | "hi" | "min" | "median" | "max">, isPe: boolean): string {
  const { block, window, span } = p.grid;
  const what = span < size ? `byte entropy of the first ${bytes(PORTRAIT_MAX)}` : "byte entropy";
  const per = `${count(block)} B/glyph${window > block ? ` · ${window} B window` : ""}`;
  const levels = isPe ? `${f2(p.lo)}–${f2(p.hi)} bits/byte` : `min ${f2(p.min)} · median ${f2(p.median)} · max ${f2(p.max)} bits/byte`;
  return `${name} · ${bytes(size)} · ${what} · ${per} · ${levels}`;
}
